function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7mqehzzb4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4463",
    transform: "translate(37 471)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5djwd1t4sb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4455",
    transform: "translate(3589 8403)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h19v19H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17858",
    transform: "translate(-37 -471)",
    style: {
      clipPath: "url(#7mqehzzb4a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17849",
    transform: "translate(-3549 -7929)",
    style: {
      clipPath: "url(#5djwd1t4sb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25418",
    d: "M157.694 29.407 156.288 28h-10.1v16.617h1.407v1.407h13.171V32.478zM146.94 43.865V28.752h9.036l.015.015v2.6h2.6l.015.015v12.483H146.94zm13.074 1.407h-11.667v-.655h11.012V32.135l.655.655z",
    transform: "translate(3445.115 8375.576)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25419",
    d: "M254.368 147.16a2.726 2.726 0 0 0 2.723-2.723v-.376h-2.347v-2.347h-.376a2.723 2.723 0 1 0 0 5.446zm-.376-4.658v2.311h2.308a1.971 1.971 0 1 1-2.311-2.311z",
    transform: "translate(3343.429 8265.929)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25420",
    d: "M354.73 125.29v2.347h2.347a2.347 2.347 0 0 0-2.347-2.347z",
    transform: "translate(3244.031 8281.765)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25421",
    d: "M247.04 337.15h7.493v.752h-7.493z",
    transform: "translate(3347.87 8077.482)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25422",
    d: "M204.09 337.15h.784v.752h-.784z",
    transform: "translate(3389.284 8077.482)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25423",
    d: "M204.09 390.16h.784v.752h-.784z",
    transform: "translate(3389.284 8026.368)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25424",
    d: "M247.04 390.16h7.493v.752h-7.493z",
    transform: "translate(3347.87 8026.368)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.eca5ef36fc77a5a081ca4ee96a7c4cec.svg";
export { ForwardRef as ReactComponent };